import React, {useState, useEffect} from "react";
import {connect} from "react-redux";
import Loader from "react-loaders";
import {useTranslation} from "react-i18next";
import {isEmpty, isArray, assign, clone} from "lodash";
import {loadChats} from "../../../thunks/Chats";
import {
    Form,
    Input,
    Label,
    Nav,
    NavItem,
} from "reactstrap";
import PerfectScrollbar from "react-perfect-scrollbar";
import {
    IonList,
    IonItem,
    IonLabel,
    IonAvatar, IonFabButton, IonFab, IonButton,
} from '@ionic/react';
import ChatAvatar from "../../../Components/ChatAvatar";
import {updateChatFilters} from "../../../actions/Chats";

const sendIcon = <svg width="22" height="18" viewBox="0 0 22 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0.51 18L21.5 9L0.51 0L0.5 7L15.5 9L0.5 11L0.51 18Z" fill="white"/>
</svg>;

const ListContacts = (
    {
        loadChats,
        setState,
        send,
        updateChatFilters,
        chatFilters,
        state
    }
) => {
    const {t, i18n} = useTranslation();

    const [contacts, setContacts] = useState([]);
    const [contactsVisibleLimit, setContactsVisibleLimit] = useState(20);
    const [loaderContactsScrollbar, setLoaderContactsScrollbar] = useState(true);
    const [allOldContactsLoaded, setAllOldContactsLoaded] = useState(false);
    const [searchInputValue, setSearchInputValue] = useState('');
    const [contactFilters, serContactFilters] = useState({
        search: ''
    })

    const loadContactsAPI = (extendFilters = {}, replaceOld = true, callback) => {
        /**
         * Подгрузить список контактов из API
         */
        const filtersAll = assign(
            clone(contactFilters),
            {
                limit: 20,
            },
            extendFilters,
        );
        if (filtersAll.assigned_to_id === null) {
            delete filtersAll.assigned_to_id;
            // Это ГРЯЗНЫЙ ХАК, т.к. DRF не умеет сам по себе фильтровать Null - значения.
            //   Цифра "2" - обязательная
            filtersAll.unassigned = 2;
        }

        loadChats(
            filtersAll,
            (response) => {
                if (replaceOld) {
                    setContacts(response.results);
                } else {
                    setContacts([...contacts, ...response.results]);
                }
                setLoaderContactsScrollbar(false);
                callback && callback(response);
            }
        );
    }

    useEffect(() => {
        loadContactsAPI({});
    }, [contactFilters]);

    const onContactsScroll = (element) => {
        if (element.scrollTop + element.clientHeight + 60 < element.scrollHeight) {
            // Еще не доскроллили до конца
            return;
        }

        if (loaderContactsScrollbar) {
            // Уже отослали запрос
            return;
        }

        if (allOldContactsLoaded) {
            // Все старые контакты уже загружены
            return;
        }

        if (contacts.length - contactsVisibleLimit < 2) {
            const filters = contactFilters;
            if (!isEmpty(contacts)) {
                filters['last_message_time__lt'] = contacts[contacts.length - 1].last_message_time;
            }

            setLoaderContactsScrollbar(true);
            loadContactsAPI(
                filters,
                false,
                (response) => {
                    if (response.next === null) {
                        setAllOldContactsLoaded(true);
                    }
                }
            );
        }

        setContactsVisibleLimit(contactsVisibleLimit + 20);
    }

    const checkboxContact = (contactId, checked) => {
        let contact = contacts.filter(contact => contact.id === contactId)[0];

        if (checked) {
            setState(state => [
                ...state,
                {
                    "name": contact.bot_user.name,
                    "phone": contact.bot_user.messenger_user_id
                }
            ])
        } else {
            setState(state => state.filter(({phone}) => phone !== contact.bot_user.messenger_user_id))
        }
    }
    const lowerCaseSearch = chatFilters.search ? chatFilters.search.toString().toLowerCase() : '';

    const contactsHTML = !isEmpty(contacts) && contacts
        .filter((item) => {
            if (!chatFilters.search) {
                return true
            } else {
                return item.id_in_messenger?.indexOf(lowerCaseSearch) !== -1 || item.name?.toLowerCase().indexOf(lowerCaseSearch) !== -1
            }
        })
        .slice(0, contactsVisibleLimit)
        .map(contact => {
            return <IonItem button key={contact.id} className="i-chats-list-item"
                            onClick={() => checkboxContact(contact.id, !state?.filter(({phone}) => phone === contact.bot_user.messenger_user_id).length)}>
                <IonAvatar slot="start" className="i-chats-list-item-avatar">
                    <ChatAvatar chat={contact}/>
                </IonAvatar>
                <IonLabel className="i-chats-list-item-label">
                    <span className="i-chats-list-item-heading">{contact.name}</span>
                </IonLabel>
                {/* <IonCheckbox
                        checked={!!state?.filter(({phone}) => phone === contact.bot_user.messenger_user_id).length}
                        onIonChange={(e) => checkboxContact(contact.id, e.target.checked)}
                    /> */}
                {
                    !!state?.filter(({phone}) => phone === contact.bot_user.messenger_user_id).length
                    && <div className="i-chats-list-item-number_messages i-chats-list-item-number_messages-green"></div>
                }
            </IonItem>
        });


    const onSearchSubmit = (event, val = null) => {
        event.preventDefault();

        if (val === null && searchInputValue === contactFilters.search) {
            // Уже сделали поиск по этому запросу
            return;
        }

        serContactFilters({
            search: val != null ? val : searchInputValue
        });
        setAllOldContactsLoaded(false);
    }

    return <>
        <form onSubmit={onSearchSubmit}>
            <div>
                {/*<Input*/}
                {/*    placeholder={t('pages.contacts.contacts.placeholder_search', "Search...")}*/}
                {/*    value={searchInputValue}*/}
                {/*    onChange={(event) => setSearchInputValue(event.target.value)}*/}
                {/*/>*/}
                {
                    contactFilters.search &&
                    <i className="pe-7s-close"
                       onClick={
                           (event) => {
                               setSearchInputValue('');
                               onSearchSubmit(event, '');
                           }
                       }
                    />
                }
            </div>
        </form>
        <IonList mode="md" className="i-chats-list">
            {
                isArray(contacts) && !contactsHTML
                    ? <div>
                        {t('pages.contacts.contacts.no_contacts', '🤔 No contacts')}
                    </div>
                    : contactsHTML
            }
            {/*{*/}
            {/*    loaderContactsScrollbar*/}
            {/*    && <div>*/}
            {/*        <Loader type="line-scale-party"/>*/}
            {/*    </div>*/}
            {/*}*/}
        </IonList>
        <IonFab vertical="bottom" horizontal="end" slot="fixed">
            <IonFabButton onClick={() => {
                send && send();
                updateChatFilters({
                    search: '',
                });
            }} className="i-fab" disabled={isEmpty(state)}>
                {sendIcon}
            </IonFabButton>
        </IonFab>
    </>
}

const mapStateToProps = state => ({
    chatFilters: state.Chats.chatFilters,
});

const mapDispatchToProps = dispatch => ({
    loadChats: (filters, callback) => dispatch(loadChats(filters, callback)),
    updateChatFilters: (filtersToUpdate) => dispatch(updateChatFilters(filtersToUpdate)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ListContacts);
